import classNames from "classnames";
import React from "react";

interface VisibleToExternalIconProps {
  visibleToExternal: boolean
  style?: React.CSSProperties
  size?: "small" | "big"
}

const VisibleToExternalIcon = (props: VisibleToExternalIconProps) => {
  const { visibleToExternal, style, size } = props;

  return <div className="s1_compositedicon tooltiptarget" title={visibleToExternal ? RESX.GeneralLabels.VisibleToExternalUsers : RESX.GeneralLabels.NotVisibleToExternalUsers} style={style}>
    <span className={classNames("icon-eye", {
      [size]: size !== undefined
    })}></span>
    {!visibleToExternal && <span className={classNames("icon-forbidden layered", {
      [size]: size !== undefined,
    })}></span>}
  </div>;
};

export default VisibleToExternalIcon;